// @ts-strict-ignore
import { ConnectionCubeSearchRequirements } from './connection-cube-search-requirements';
import { Dictionary } from 'typescript-collections';
import { PropertyVO } from '@project/components/article/model/vo/property.vo';
import { Connection } from '@3d-scene/model3d/connection';

export class ConnectionCubeSearchVector {
  public id: number;
  public sortedCubesSearchRequirements: ConnectionCubeSearchRequirements[];
  public searchForMultipleGivingConnections: boolean;
  public searchForFreedomConnectionTarget: boolean = false;
  // key: cube uid, value: array of additional properties
  public additionalPropertiesMap: Dictionary<string, PropertyVO[]>;
  public directionAxis: string;
  public equalAxis: string;

  public constructor(id: number, sortedCubesSearchRequirements: ConnectionCubeSearchRequirements[],
    searchForMultipleGivingConnections: boolean, directionAxis: string = null, equalAxis: string = null) {
    this.id = id;
    this.sortedCubesSearchRequirements = sortedCubesSearchRequirements;
    this.searchForMultipleGivingConnections = searchForMultipleGivingConnections;
    this.directionAxis = directionAxis;
    this.equalAxis = equalAxis;
  }

  public getConnectionCubeIds(): string[] {
    if (!this.sortedCubesSearchRequirements) {
      return [];
    }
    const cubeIds: string[] = [];
    for (const cubeRequirement of this.sortedCubesSearchRequirements) {
      cubeIds.push(cubeRequirement.cubeUID);
    }
    return cubeIds;
  }

  public getAdditionalRequirementsByCubeUid(cubeUid: string): PropertyVO[] {
    if (!this.additionalPropertiesMap) {
      return null;
    }
    return this.additionalPropertiesMap.containsKey(cubeUid) ? this.additionalPropertiesMap.getValue(cubeUid) : null;
  }

  public getSortedConnectionCubes(): Connection[] {
    const connectionCubes: Connection[] = [];
    for (const cubeRequirements of this.sortedCubesSearchRequirements) {
      const cube: Connection = cubeRequirements.getConnectionCube();
      if (cube) {
        connectionCubes.push(cube);
      }
    }
    return connectionCubes;
  }
}
